import React from "react";
import "./meet.css";

function MeetCarePreneur() {
  return (
    <div className="meet-container">
      <div className="meet-content">
        <div className="text-section">
          <h2>
            Meet the CarePreneurs <br />
            <span>– The Heart of Wihan</span>
          </h2>
          <p>
            We don’t employ healthcare workers. We empower professionals to
            become entrepreneurs of care. Our CarePreneurs are verified,
            trained, and supported to deliver compassionate home healthcare
            services with dignity and pride.
          </p>

          <div className="counter-box">
            <p className="counter-title">
              CarePreneurs <span className="online-text">Online Now</span>
            </p>
            <div className="counter-number">
              <span>1</span>
              <span>2</span>
              <span>0</span>
              <span>0</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MeetCarePreneur;
